import Promise from 'promise'
import async from 'async'
import Request from 'modules/request'
import agent from 'superagent'
import fm from 'front-matter'

// name of actions
export const REQUEST_DATA = 'REQUEST_DATA'
export const RECEIVE_DATA = 'RECEIVE_DATA'
export const REQUEST_TEAM_DATA = 'REQUEST_TEAM_DATA'
export const RECEIVE_TEAM_DATA = 'RECEIVE_TEAM_DATA'
export const REQUEST_ARCHIVE_DATA = 'REQUEST_ARCHIVE_DATA'
export const RECEIVE_ARCHIVE_DATA = 'RECEIVE_ARCHIVE_DATA'
export const REQUEST_SEMPAI2017_DATA = 'REQUEST_SEMPAI2017_DATA'
export const RECEIVE_SEMPAI2017_DATA = 'RECEIVE_SEMPAI2017_DATA'
// export const MINIMIZE = 'MINIMIZE'
export const MENU_STATE = 'MENU_STATE'
export const FOOTER_STATE = 'FOOTER_STATE'
export const HEADER_STATE = 'HEADER_STATE'
export const REQUEST_MENU = 'REQUEST_MENU'
export const RECEIVE_MENU = 'RECEIVE_MENU'
export const REQUEST_ALERT = 'REQUEST_ALERT'
export const RECEIVE_ALERT = 'RECEIVE_ALERT'
export const TOGGLE_ANSWER = 'TOGGLE_ANSWER'
export const TOGGLE_IMAGE_GRID = 'TOGGLE_IMAGE_GRID'
export const MINIMIZE_ALERT = 'MINIMIZE_ALERT'
export const HIDE_ALERT = 'HIDE_ALERT'
export const TOGGLE_MODAL = 'TOGGLE_MODAL'
export const SELECT_USER = 'SELECT_USER'

export const IS_NAVIGATE_GALLERY = 'IS_NAVIGATE_GALLERY'
export const INFO_CAMP_2016 = 'INFO_CAMP_2016'


// actions
function requestData(url) {
  return {
    type: REQUEST_DATA,
    url: url
  }
}
function receiveData(url, data) {
  return {
    type: RECEIVE_DATA,
    url: url,
    data: data
  }
}
function requestTeamData(url) {
  return {
    type: REQUEST_TEAM_DATA,
    url: url
  }
}
function receiveTeamData(url, data) {
  return {
    type: RECEIVE_TEAM_DATA,
    url: url,
    teamData: data
  }
}
function requestArchiveData(url) {
  return {
    type: REQUEST_ARCHIVE_DATA,
    url: url
  }
}
function receiveArchiveData(url, data) {
  return {
    type: RECEIVE_ARCHIVE_DATA,
    url: url,
    archiveData: data
  }
}
function requestSempai2017Data(url) {
  return {
    type: REQUEST_SEMPAI2017_DATA,
    url: url
  }
}
function receiveSempai2017Data(url, data) {
  return {
    type: RECEIVE_SEMPAI2017_DATA,
    url: url,
    sempai2017Data: data
  }
}
function toggleMenuState(menuState) {
  return {
    type: MENU_STATE,
    menuState: menuState
  }
}
function toggleFooterState(state) {
  return {
    type: FOOTER_STATE,
    footerIsHidden: state
  }
}
function toggleHeaderState(state) {
  return {
    type: HEADER_STATE,
    headerIsHidden: state
  }
}
function isNavigateGalleryState(state) {
  return {
    type: IS_NAVIGATE_GALLERY,
    isNavigateGallery: state
  }
}
function infoCamp2016State(state) {
  return {
    type: INFO_CAMP_2016,
    infoCamp2016: state
  }
}
function requestMenu(url) {
  return {
    type: REQUEST_MENU,
    url: url
  }
}
function receiveMenu(url, data) {
  return {
    type: RECEIVE_MENU,
    url: url,
    menuData: data
  }
}
function requestAlert(url) {
  return {
    type: REQUEST_ALERT,
    url: url
  }
}
function receiveAlert(url, data) {
  return {
    type: RECEIVE_ALERT,
    url: url,
    alertData: data
  }
}
function toggleAnswerState(id) {
  return {
    type: TOGGLE_ANSWER,
    questionId: id
  }
}
function canSeeImageGrid(bool) {
  return {
    type: TOGGLE_IMAGE_GRID,
    canSeeImageGrid: bool
  }
}
function alertIsMinimized(bool) {
  return {
    type: MINIMIZE_ALERT,
    alertIsMinimized: bool
  }
}
function alertIsHidden(bool) {
  return {
    type: HIDE_ALERT,
    alertIsHidden: bool
  }
}
function toggleModalState(obj) {
  return {
    type: TOGGLE_MODAL,
    modalState: obj
  }
}
function userSelected(id) {
  return {
    type: SELECT_USER,
    userId: id
  }
}

// action creators
export function fetchData(url) {
  return function(dispatch) {
    // update state to inform that a call is starting
    dispatch(requestData(url))

    // clean up with promise
    agent
      .get(url)
      .end((err, res) => {
        let yaml = fm(res.text)
        let data = yaml.attributes
        dispatch(receiveData(url, data))
      })
  }
}

export function fetchTeamData(url) {
  return function(dispatch) {
    dispatch(requestTeamData(url))
    agent
      .get(url)
      .end((err, res) => {
        let yaml = fm(res.text)
        let data = yaml.attributes
        dispatch(receiveTeamData(url, data))
      })
  }
}

export function fetchArchiveData(url) {
  return function(dispatch) {
    dispatch(requestArchiveData(url))
    agent
      .get(url)
      .end((err, res) => {
        let yaml = fm(res.text)
        let data = yaml.attributes
        dispatch(receiveArchiveData(url, data))
      })
  }
}

export function fetchSempai2017Data(url) {
  return function(dispatch) {
    dispatch(requestSempai2017Data(url))
    agent
      .get(url)
      .end((err, res) => {
        let yaml = fm(res.text)
        let data = yaml.attributes
        dispatch(receiveSempai2017Data(url, data))
      })
  }
}

export function toggleMenu(menuState) {
  return dispatch => {
    dispatch(toggleMenuState(menuState))
  }
}

export function toggleFooter(state) {
  return dispatch => {
    dispatch(toggleFooterState(state))
  }
}

export function toggleHeader(state) {
  return dispatch => {
    dispatch(toggleHeaderState(state))
  }
}

export function isNavigateGallery(state) {
  return dispatch => {
    dispatch(isNavigateGalleryState(state))
  }
}

export function infoCamp2016(state) {
  return dispatch => {
    dispatch(infoCamp2016State(state))
  }
}

export function fetchMenu(url) {
  return function(dispatch) {
    dispatch(requestMenu(url))
    agent
      .get(url)
      .end((err, res) => {
        let yaml = fm(res.text)
        let data = yaml.attributes
        dispatch(receiveMenu(url, data))
      })
  }
}

export function fetchAlert(url) {
  return function(dispatch) {
    dispatch(requestAlert(url))
    agent
      .get(url)
      .end((err, res) => {
        let yaml = fm(res.text)
        let data = yaml.attributes
        dispatch(receiveAlert(url, data))
      })
  }
}
export function toggleAnswer(id) {
  return dispatch => {
    dispatch(toggleAnswerState(id))
  }
}
export function toggleImageGridVisibility(bool) {
  return dispatch => {
    dispatch(canSeeImageGrid(bool))
  }
}

export function toggleMinimizeAlert(bool) {
  return dispatch => {
    dispatch(alertIsMinimized(bool))
  }
}
export function toggleHideAlert(bool) {
  return dispatch => {
    dispatch(alertIsHidden(bool))
  }
}
export function toggleModal(obj) {
  return dispatch => {
    dispatch(toggleModalState(obj))
  }
}

export function selectUser(id) {
  return dispatch => {
    dispatch(userSelected(id))
  }
}


// examples:

export const REQUEST_TOKEN_INIT = 'REQUEST_TOKEN_INIT'
export const REQUEST_TOKEN_FETCHLIST = 'REQUEST_TOKEN_FETCHLIST'
export const RECEIVE_TOKEN_FETCHLIST = 'RECEIVE_TOKEN_FETCHLIST'
export const REQUEST_TOKEN_PERMISSION_FETCHLIST = 'REQUEST_TOKEN_PERMISSION_FETCHLIST'
export const RECEIVE_TOKEN_PERMISSION_FETCHLIST = 'RECEIVE_TOKEN_PERMISSION_FETCHLIST'
export const REQUEST_TOKEN_REVOKE = 'REQUEST_TOKEN_REVOKE'
export const RECEIVE_TOKEN_REVOKE = 'RECEIVE_TOKEN_REVOKE'
export const REQUEST_TOKEN_PERMISSION_DELETE = 'REQUEST_TOKEN_PERMISSION_DELETE'
export const RECEIVE_TOKEN_PERMISSION_DELETE = 'RECEIVE_TOKEN_PERMISSION_DELETE'
export const REQUEST_TOKEN_PERMISSION_ADD = 'REQUEST_TOKEN_PERMISSION_ADD'
export const RECEIVE_TOKEN_PERMISSION_ADD = 'RECEIVE_TOKEN_PERMISSION_ADD'
export const REQUEST_TOKEN_ADD = 'REQUEST_TOKEN_ADD'
export const RECEIVE_TOKEN_ADD = 'RECEIVE_TOKEN_ADD'
export const REQUEST_TOKEN_SYNC = 'REQUEST_TOKEN_SYNC'
export const RECEIVE_TOKEN_SYNC = 'RECEIVE_TOKEN_SYNC'
export const REQUEST_TOKEN_FETCH = 'REQUEST_TOKEN_FETCH'
export const RECEIVE_TOKEN_FETCH = 'RECEIVE_TOKEN_FETCH'

//
export function permissionFetchList(tokenId) {
  return (dispatch, getState) => {
    return new Promise(function(resolve, reject) {
      let state = getState()
      let req = {
        persist:state.persist,
        token:state.persist.token,
        endpoint:'token/permissions/' + tokenId,
        ID:tokenId,
        data:{
          cursor:state.token.objects[tokenId].permissions ? state.token.objects[tokenId].permissionscursor : undefined
        }
      }
      dispatch(requestPermissionFetchList(req))
      return Request(req).then(res => {
        dispatch(receivePermissionFetchList(req, res))
      })
    })
  }
}
export function fetchList(data) {
  if(!data) data = {}
  return (dispatch, getState) => {
    return new Promise(function(resolve, reject) {
      let state = getState()
      let req = {
        persist:state.persist,
        token:state.persist.token,
        endpoint:'user/tokens',
        data:{
          cursor:data.cursor || state.token.cursor
        }
      }
      dispatch(requestFetchList(req))
      return Request(req).then(res => {
        dispatch(receiveFetchList(req, res))
      })
    })
  }
}
export function revoke(tokenId) {
  return (dispatch, getState) => {
    return new Promise(function(resolve, reject) {
      let state = getState()
      let req = {
        persist:state.persist,
        method:'delete',
        token:state.persist.token,
        ID:tokenId,
        endpoint:'token/object/' + tokenId
      }
      dispatch(requestRevoke(req))
      return Request(req).then(res => {
        dispatch(receiveRevoke(req, res))
      })
    })
  }
}
export function add() {
  return (dispatch, getState) => {
    return new Promise(function(resolve, reject) {
      let state = getState()
      let req = {
        persist:state.persist,
        method:'post',
        token:state.persist.token,
        endpoint:'token/object'
      }
      dispatch(requestAdd(req))
      return Request(req).then(res => {
        dispatch(receiveAdd(req, res))
      })
    })
  }
}
export function permissionAdd(tokenId, data) {
  return (dispatch, getState) => {
    return new Promise(function(resolve, reject) {
      let state = getState()
      let req = {
        persist:state.persist,
        method:'post',
        token:state.persist.token,
        ID:tokenId,
        endpoint:'token/permission/' + tokenId,
        data : data
      }
      dispatch(requestPermissionAdd(req))
      return Request(req).then(res => {
        dispatch(receivePermissionAdd(req, res))
      })
    })
  }
}
export function permissionDelete(tokenId, permissionId) {
  return (dispatch, getState) => {
    return new Promise(function(resolve, reject) {
      let state = getState()
      let req = {
        persist:state.persist,
        method:'delete',
        ID:tokenId,
        token:state.persist.token,
        endpoint:'token/permission/' + tokenId + '/' + permissionId
      }
      dispatch(requestPermissionDelete(req))
      return Request(req).then(res => {
        dispatch(receivePermissionDelete(req, res))
      })
    })
  }
}
export function sync(tokenId) {
  return (dispatch, getState) => {
    return new Promise(function(resolve, reject) {
      let state = getState()
      let req = {
        persist:state.persist,
        token:state.persist.token,
        ID:tokenId,
        endpoint:tokenId ? 'token/object/' + tokenId : 'user/tokens'
      }
      dispatch(requestSync(req))
      return Request(req).then(res => {
        dispatch(receiveSync(req, res))
      })
    })
  }
}
export function fetch(tokenId) {
  return (dispatch, getState) => {
    return new Promise(function(resolve, reject) {
      let state = getState()
      let req = {
        persist:state.persist,
        token:state.persist.token,
        ID:tokenId,
        endpoint:'token/object/' + tokenId
      }
      dispatch(requestFetch(req))
      return Request(req).then(res => {
        dispatch(receiveFetch(req, res))
      })
    })
  }
}
function requestAdd(req) {
  return {
    type: REQUEST_TOKEN_ADD,
    request:req
  }
}
function receiveAdd(req, res) {
  return {
    type: RECEIVE_TOKEN_ADD,
    request:req,
    response:res
  }
}
function requestPermissionAdd(req) {
  return {
    type: REQUEST_TOKEN_PERMISSION_ADD,
    request:req
  }
}
function receivePermissionAdd(req, res) {
  return {
    type: RECEIVE_TOKEN_PERMISSION_ADD,
    request:req,
    response:res
  }
}
function requestPermissionDelete(req) {
  return {
    type: REQUEST_TOKEN_PERMISSION_DELETE,
    request:req
  }
}
function receivePermissionDelete(req, res) {
  return {
    type: RECEIVE_TOKEN_PERMISSION_DELETE,
    request:req,
    response:res
  }
}
function requestRevoke(req) {
  return {
    type: REQUEST_TOKEN_REVOKE,
    request:req
  }
}
function receiveRevoke(req, res) {
  return {
    type: RECEIVE_TOKEN_REVOKE,
    request:req,
    response:res
  }
}
function requestSync(req) {
  return {
    type: REQUEST_TOKEN_SYNC,
    request:req
  }
}
function receiveSync(req, res) {
  return {
    type: RECEIVE_TOKEN_SYNC,
    request:req,
    response:res
  }
}
function requestFetch(req) {
  return {
    type: REQUEST_TOKEN_FETCH,
    request:req
  }
}
function receiveFetch(req, res) {
  return {
    type: RECEIVE_TOKEN_FETCH,
    request:req,
    response:res
  }
}
function requestPermissionFetchList(req) {
  return {
    type: REQUEST_TOKEN_PERMISSION_FETCHLIST,
    request:req
  }
}
function receivePermissionFetchList(req, res) {
  return {
    type: RECEIVE_TOKEN_PERMISSION_FETCHLIST,
    request:req,
    response:res
  }
}
function requestFetchList(req) {
  return {
    type: REQUEST_TOKEN_FETCHLIST,
    request:req
  }
}
function receiveFetchList(req, res) {
  return {
    type: RECEIVE_TOKEN_FETCHLIST,
    request:req,
    response:res
  }
}
export function init() {
  return {
    type: REQUEST_TOKEN_INIT
  }
}



// WEBPACK FOOTER //
// ./src/actions/token.js